import localforage from "localforage";
import { SecureForage } from "@/utils/localforage/secureforage";
import { COLLECTION_KEYS as CK } from "@/utils/localforage/collectionkeys";

// Configuración principal para Google Chrome y Safari
const DB_NAME = "RISKMANN-BY-SOFU";
const MASTER_PASSPHRASE = process.env.LOCALFORAGE_SECRET_PHRASE;

localforage.config({
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE], // Prioriza IndexedDB
  name: DB_NAME, // Nombre de la base de datos // PELIGRO: SI SE CAMBIA EL NOMBRE, SE PIERDEN LOS DATOS.
  storeName: "keyvaluepairs", // Nombre del almacén de datos
  version: 1.0, // Versión de la base de datos // PELIGRO: SI SE CAMBIA LA VERSIÓN, SE PIERDEN LOS DATOS.
  size: 50 * 1024 * 1024, // 50MB de almacenamiento máximo para WebSQL (en Safari)
  description: `Base de datos local para el almacenamiento persistente de usuarios y registros de RISKMANN-BY-SOFU.`,
});

// Verificar qué driver está en uso
localforage
  .ready()
  .then(() => {
    console.log("🚀 Driver en uso:", localforage.driver());
  })
  .catch((error) => {
    console.error("❌ Error al configurar localforage:", error);
  });

// Crear almacenes independientes para distintos tipos de datos
export const riskmannRutogramasStore = new SecureForage(
  CK.rutogramas.registros,
  MASTER_PASSPHRASE
);

export const riskmannRutogramasRespaldoStore = new SecureForage(
  `${CK.rutogramas.registros}_rsp`,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialFormatosStore = new SecureForage(
  CK.seguridadVial.formatos.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialInspeccionesStore = new SecureForage(
  CK.seguridadVial.inspecciones.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialPlanDesplazamientosTerrestresStore =
  new SecureForage(
    CK.seguridadVial.planesDesplazamientos.registros,
    MASTER_PASSPHRASE
  );

export const riskmannSeguridadVialConductoresStore = new SecureForage(
  CK.seguridadVial.conductores.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialVehiculosStore = new SecureForage(
  CK.seguridadVial.vehiculos.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialConductoresCapacitacionesStore =
  new SecureForage(
    CK.seguridadVial.conductores.capacitaciones.registros,
    MASTER_PASSPHRASE
  );

export const riskmannSeguridadVialConductoresExamenesStore = new SecureForage(
  CK.seguridadVial.conductores.examenes.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialConductoresLicenciasStore = new SecureForage(
  CK.seguridadVial.conductores.licencias.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialConductoresRevisionesStore = new SecureForage(
  CK.seguridadVial.conductores.revisiones.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialConductoresAptitudesStore = new SecureForage(
  CK.seguridadVial.aptitudes.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialVehiculosDocumentosStore = new SecureForage(
  CK.seguridadVial.vehiculos.documentos.registros,
  MASTER_PASSPHRASE
);

export const riskmannSeguridadVialVehiculosRevisionesDocumentosStore =
  new SecureForage(
    CK.seguridadVial.vehiculos.revisiones.registros,
    MASTER_PASSPHRASE
  );

export const riskmannSeguridadVialVehiculosKilometrajesStore = new SecureForage(
  CK.seguridadVial.vehiculos.kilometrajes.registros,
  MASTER_PASSPHRASE
);

export const riskmannPaisesStore = new SecureForage(
  CK.paises,
  MASTER_PASSPHRASE
);

export const riskmannDepartamentosStore = new SecureForage(
  CK.departamentos,
  MASTER_PASSPHRASE
);

export const riskmannCiudadesStore = new SecureForage(
  CK.ciudades,
  MASTER_PASSPHRASE
);

export const riskmannModoSinConexionStore = new SecureForage(
  CK.modoSinConexion,
  MASTER_PASSPHRASE
);

export const riskmannUsuarioLocalStore = new SecureForage(
  CK.usuarios.local,
  MASTER_PASSPHRASE
);

export default localforage;
